'use strict';

const APP_CONSTANTS = require(`./data/${ process.env.USE_CONFIG }.constants.json`);
APP_CONSTANTS.IS_BUILD = process.env.PRODUCTION;
const ConfigModule = angular
  .module('nownessApp.config', [])
  .constant('APP_CONSTANTS', APP_CONSTANTS);

export default ConfigModule.name;



// WEBPACK FOOTER //
// ./app/config/config.module.js